import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import store from "../store";
import httpClient from "../store/httpClient";

Vue.use(VueRouter);

let router = new VueRouter({
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.name === "capacity" || to.name === "manufacturingOverview") {
		next();
		return;
	}
	var fertigerId = parseInt(to.params.fertigerId);
	var currentFertiger = store.state.fertiger.filter((f) => f.id === fertigerId);
	if (
		currentFertiger.length === 1 &&
		(store.state.beanstandungLoadedForFertigerId === undefined ||
			store.state.beanstandungLoadedForFertigerId !== fertigerId)
	) {
		store.dispatch("getBeanstandungCount", fertigerId);
	}
	if (currentFertiger.length === 1 || to.name === "fertiger") {
		next();
	} else {
		if (store.state.fertiger.length === 1) {
			// there is only one fertiger the user is allowed to access
			console.log(
				"Es gibt nur einen erlaubten Fertiger. Redirecting zum erlaubten Fertiger."
			);
			router.push({ name: "order", params: { fertigerId: store.state.fertiger[0].id } });
		} else {
			console.log("Fertiger ist nicht definiert. Redirecting zur Auswahl.");
			next({ name: "fertiger" });
		}
	}
});

export default router;
